import styled from 'styled-components';
import { Form, Input, Button } from 'antd';

interface LoginFormData {
  phone: string;
  code: string;
  countryCode: string;
}

// 主容器 - 全屏布局
export const LoginContainer = styled.div`
  display: flex;
  height: calc(var(--vh, 1vh) * 100);
  width: 100vw;
  background-color: #000000;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

// 左侧区域 - 占一半，视频背景
export const LeftSection = styled.div`
  flex: 1;
  background-color: #000000;
  min-height: calc(var(--vh, 1vh) * 100);
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    display: none;
  }
`;

// 右侧区域 - 登录区域
export const RightSection = styled.div`
  flex: 1;
  box-sizing: border-box;
  background-color: #121212;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  min-height: calc(var(--vh, 1vh) * 100);

  @media (max-width: 768px) {
    padding: 20px;
  }

  @media (max-width: 480px) {
    padding: 16px;
  }
`;

// 登录内容容器
export const LoginContent = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 60px 40px;

  @media (max-width: 768px) {
    padding: 40px 20px;
    align-items: center;
  }

  @media (max-width: 480px) {
    padding: 20px 16px;
  }
`;

// 欢迎标题
export const WelcomeTitle = styled.h1`
  color: #ffffff;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 0px;
  margin-bottom: 40px;
  text-align: center;
  width: 100%;

  @media (max-width: 768px) {
    font-size: 28px;
    text-align: center;
    margin-bottom: 32px;
  }

  @media (max-width: 480px) {
    font-size: 24px;
    margin-bottom: 24px;
  }
`;

export const SectionTitle = styled.h2`
  color: #fff;
  margin-top: 0px;
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-family:
    'PingFang SC',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    'Helvetica Neue',
    Arial,
    sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 114.286% */
  margin-bottom: 24px;
  text-align: left;
  width: 100%;
`;

// 登录表单
export const LoginForm = styled(Form<LoginFormData>)`
  width: 100%;

  .ant-form-item {
    margin-bottom: 32px;
  }

  .ant-form-item-label > label {
    color: rgba(255, 255, 255, 0.85);
    font-size: 14px;
  }

  .ant-form-item-explain-error {
    color: #ff4d4f;
    font-size: 12px;
  }

  @media (max-width: 768px) {
    .ant-form-item {
      margin-bottom: 24px;
    }
  }
`;

// 输入框容器基础样式
const BaseInputContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  border: 1px solid #777;
  border-radius: 8px;
  background-color: #121212;
  transition: border-color 0.2s ease;
  overflow: hidden;

  &:hover {
    border-color: #fff;
  }

  &:focus-within {
    border-color: #fff;
  }
`;

// 手机号输入框容器
export const PhoneInputContainer = styled(BaseInputContainer)``;

// 验证码容器
export const VerificationContainer = styled(BaseInputContainer)`
  justify-content: space-between;
  padding-right: 10px;
`;

// 手机号前缀
export const PhonePrefix = styled.div`
  padding: 0 18px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 16px;
  font-weight: 400;
  white-space: nowrap;
  display: flex;
  align-items: center;
  height: 100%;
`;

// 手机号分隔线
export const PhoneDivider = styled.div`
  display: block;
  width: 1px;
  height: 14.5px;
  background-color: #fff;
  opacity: 0.3;
  flex-shrink: 0;
`;

// 输入框基础样式
const BaseInput = styled(Input)`
  flex: 1;
  background-color: transparent;
  border: none !important;
  color: rgba(255, 255, 255, 0.85);
  font-size: 16px;
  height: 48px;
  padding: 0 18px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.45);
  }

  &:hover {
    border: none;
    box-shadow: none;
  }

  &:focus {
    border: none;
    box-shadow: none;
  }

  .ant-input {
    background-color: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.85);
    font-size: 16px;

    &::placeholder {
      color: rgba(255, 255, 255, 0.45);
    }

    &:hover {
      border: none;
      box-shadow: none;
    }

    &:focus {
      border: none;
      box-shadow: none;
    }
  }
`;

// 手机号输入框
export const PhoneInput = styled(BaseInput)``;

// 验证码输入框
export const VerificationInput = styled(BaseInput)``;

// 验证码分隔线
export const VerificationDivider = styled.div`
  display: none;
`;

// 发送验证码按钮
export const SendCodeButton = styled(Button)`
  height: 40px;
  padding: 0 16px;
  border-radius: 7px;
  border: none !important;
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px; /* 150% */
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;

  /* Enabled state */
  &:not(:disabled) {
    background: #ff6d49;
    color: #fff;
    cursor: pointer;
  }

  /* Hover state when enabled */
  &:not(:disabled):hover {
    background: #ff886b;
  }

  /* Disabled state */
  &:disabled {
    background: #2b2b2b;
    color: #979797;
    cursor: not-allowed;
  }

  /* Countdown state (also disabled, but with different text color) */
  &.countdown:disabled {
    color: #fff;
  }
`;

// 协议说明文字
export const AgreementText = styled.div`
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.65);
  font-size: 12px;
  margin-bottom: 32px;
  line-height: 1.5;
  width: 100%;
`;

// 协议链接
export const AgreementLink = styled.a`
  color: #dc5d33 !important;
  text-decoration: none;

  &:hover {
    color: #dc5d33 !important;
    text-decoration: underline;
  }

  &:visited {
    color: #dc5d33 !important;
  }

  &:active {
    color: #dc5d33 !important;
  }

  &:focus {
    color: #dc5d33 !important;
  }

  &:link {
    color: #dc5d33 !important;
  }
`;

// 提交按钮
export const SubmitButton = styled(Button)`
  width: 100%;
  height: 50px !important;
  border: none !important;
  border-radius: 10px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  outline: none !important;
  box-shadow: none !important;

  /* 覆盖所有可能的边框状态 */
  &:hover,
  &:focus,
  &:active,
  &.ant-btn:hover,
  &.ant-btn:focus,
  &.ant-btn:active {
    border: none !important;
    outline: none !important;
  }

  /* 默认状态 - 灰色背景 */
  &:disabled {
    background: #666 !important;
    color: #fff !important;
    border: none !important;
    outline: none !important;
    transform: none;
    box-shadow: none !important;
    cursor: not-allowed;

    &::before {
      display: none;
    }
  }

  /* 启用状态 - 渐变背景 */
  &:not(:disabled) {
    background: linear-gradient(123deg, #feae45 19.66%, #ff6d49 67.36%) !important;
    border: none !important;
    outline: none !important;
    box-shadow: 0 4px 12px rgba(255, 106, 57, 0.3) !important;
  }

  /* hover遮罩层 */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
      linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
      linear-gradient(123deg, #feae45 19.66%, #ff6d49 67.36%);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover:not(:disabled) {
    &::before {
      opacity: 1;
    }
  }

  &:active:not(:disabled) {
    transform: scale(0.98);
  }

  /* 确保内容在伪元素之上 */
  & > * {
    position: relative;
    z-index: 1;
  }
`;

// 箭头图标
export const ArrowIcon = styled.span`
  width: 14px;
  height: 12.727px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 14px;
    height: 13px;
    fill: white;
  }
`;
export const Ttilt = styled.div`
  font-size: 12px;
  line-height: 12px;
  font-family: Inter;
  color: #fff;
  text-align: center;
  opacity: 0.6;
  margin-bottom:17px;
`;

